import { useDevicePosition } from "core/hooks/useDevicePosition";
import useSWR from "swr";

export type LocationLookupData = {
  provinceStateCode: string;
  countryIsoTwoAlphaCode: string;
};

export function useLocationLookup() {
  const { position } = useDevicePosition(true);
  const key = position
    ? `/api/location-lookup?lat=${position.coords.latitude}&lng=${position.coords.longitude}`
    : null;
  return useSWR<{ provinceStateCode: string; countryIsoTwoAlphaCode: string }>(
    key,
    (...args: Parameters<typeof fetch>) =>
      fetch(...args).then((res) => res.json())
  );
}
